<template>
  <div v-if="!mountOnDisplay || isActive" v-show="isActive" class="pt-4 px-12">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    // Non localized reference used for direct routing and selection
    refName: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    selected: {
      Type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Only mount the data when the tab is displayed
    mountOnDisplay: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isActive: false,
    };
  },

  computed: {
    href() {
      if (this.refName) {
        return "#" + this.refName.toLowerCase().replace(/ /g, "-");
      }
      // Fallback to a localized name
      return "#" + this.name.toLowerCase().replace(/ /g, "-");
    },
  },

  mounted() {
    this.isActive = this.selected;
  },
};
</script>
